import React from 'react'

const AssetIcon = (props) => {
  const { size, color } = props
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width={size} height={size}>
      <path
        fill={color}
        d="M8 207.5V415h190v-70H49V40h195v36h41V0H8v207.5zm149.6 161.1c6.7 3.2 9.3 11.7 5.5 18-1.9 3.1-7.4 6.4-10.6 6.4-3.2 0-8.5-3.2-10.5-6.5-3.9-6.3-1.4-14.6 5.3-17.9 4.1-2 6.1-2 10.3 0z"
      />
      <path
        fill={color}
        d="M227 304.5V512h277V97H227v207.5zm236-14V443H268V138h195v152.5zm-83.3 178.9c5.3 5.8 5.6 10.8.7 16.5-3.7 4.4-9.1 5.8-13.8 3.6-10-4.7-10.7-16.7-1.3-22.6 4.7-3 10.3-2 14.4 2.5z"
      />
    </svg>
  )
}

AssetIcon.defaultProps = {
  size: 30,
  color: '#555555',
}

export default AssetIcon
